/**
 * `2026-08-15 20:41:53 UTC` — sortable-looking and unambiguous, which a locale string
 * is not. Used by the ops surfaces where a timestamp is evidence to be compared
 * and quoted (the webhook ledger, the audit log).
 *
 * A no-break space keeps `UTC` with the time, so a narrow cell wraps after the date.
 *
 * Falls back to the raw value rather than throwing: `toISOString()` raises on an
 * unparseable date, which would take a whole table down over one bad cell.
 *
 * @param {string} iso - Timestamp as the API serialized it.
 * @returns {string} `YYYY-MM-DD HH:MM:SS UTC`, or `iso` unchanged if unparseable.
 */
export const formatUtc = (iso: string): string => {
	const parsed = new Date(iso)
	return Number.isNaN(parsed.getTime()) ? iso : `${parsed.toISOString().replace('T', ' ').slice(0, 19)}\u00a0UTC`
}
